import React, { useMemo } from 'react';
import VoxelAutocomplete, {
  GenericOption,
  VoxelAutocompleteProps,
} from '../../voxel/Forms/VoxelAutocomplete';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';

export interface VoxelAutocompleteTagGroupProps
  extends Omit<
    VoxelAutocompleteProps,
    'setSelectedOptions' | 'options' | 'selectedOptionValues' | 'fixedOptions' | 'freeAdd' | 'multi'
  > {
  project: ProjectGq;
  tagGroupId?: number;
  setTagGroupId: (tagGroupId?: number) => void;
}

export const VoxelAutocompleteTagGroup: React.FC<VoxelAutocompleteTagGroupProps> = ({
  project,
  tagGroupId,
  setTagGroupId,
  label,
  labelPosition,
  ...forwardedProps
}) => {
  const options = useMemo(
    () => project.tagGroups.map((tg): GenericOption => ({ title: tg.name, value: tg.id })),
    [project.tagGroups]
  );

  const selectedOptionValues = useMemo(() => (tagGroupId ? [tagGroupId] : []), [tagGroupId]);
  tagGroupId;
  return (
    <VoxelAutocomplete
      {...forwardedProps}
      options={options}
      selectedOptionValues={selectedOptionValues}
      setSelectedOptions={(options) => {
        const option = options[0];
        setTagGroupId(option.value);
      }}
      label={label ?? 'Tag group'}
      labelPosition={labelPosition ?? 'top'}
      emptyAllowed={false}
    />
  );
};

export default VoxelAutocompleteTagGroup;
